import { useAppSelector } from '../../utils/useAppSelector'
import { LOGIN_STATUS } from '../user/userSlice'

export const useIsLoggedIn = () => {
  const isLoggedIn = useAppSelector((state) => state.user.loginStatus === LOGIN_STATUS.LOGGED_IN)
  const isHydrated = useAppSelector((state) => state.user._persist?.rehydrated)
  const tokenDefined = useAppSelector((state) => state.user.token !== null)
  if (!isHydrated || !tokenDefined || !isLoggedIn) {
    return false
  }
  return true
}

export const useIsLoggedInV2 = () => {
  const isLoggedIn = useAppSelector((state) => state.user.loginStatus === LOGIN_STATUS.LOGGED_IN)
  const isHydrated = useAppSelector((state) => state.user._persist?.rehydrated)
  const tokenDefined = useAppSelector((state) => state.user.token !== null)
  return { isLoggedIn, isHydrated, tokenDefined }
}
